import { render } from "./AverageExchange.vue?vue&type=template&id=1075cfb3"
import script from "./AverageExchange.vue?vue&type=script&lang=js"
export * from "./AverageExchange.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__